// extracted by mini-css-extract-plugin
export default {"backCard":"BackCard_backCard__HY9AD","pickACard":"BackCard_pickACard__3OTww","heartBeat":"BackCard_heartBeat__ypXLp","pickButton":"BackCard_pickButton__SjLoY"};